import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { GrFormClose } from "react-icons/gr";
import { InputSelect, InputText } from "../../helpers/FormInputs";
import fetchApi from "../../helpers/fetchApi";
import { devApiUrl, handleKey } from "../../helpers/general-functions";
import SpinnerButton from "../../widget/SpinnerButton";
import { StoreContext } from "../../../store/StoreContext";
import { setError, setMessage, setResultSet } from "../../../store/StoreAction";
import useFetchBranch from "../../custom-hooks/useFetchBranch";
import useLoadAll from "../../custom-hooks/useLoadAll";
import { isRoleCashier } from "../login/login-functions";
// import useLoadCoordinators from "../../custom-hooks/useLoadCoordinators";

const ModalAddMember = ({ props, add }) => {
  const { store, dispatch } = React.useContext(StoreContext);
  const [loading, setLoading] = React.useState(false);
  const [isCidExist, setIsCidExist] = React.useState(false);
  const isCashier = isRoleCashier(store.credentials.role_name);
  const [text, setText] = React.useState("with auto-generated CID");
  const { resultData } = useFetchBranch("/admin/branch/read-branch-all.php");
  const { result } = useLoadAll("/admin/program-list/read-programlist-all.php");

  const { setAdd } = add;

  const initVal = {
    members_cid: "",
    members_branch_id: isCashier ? store.credentials.users_branch_id : "",
    members_programlist_id: "",
    members_fname: "",
    members_mname: "",
    members_lname: "",
    members_agent: "root-1",
    // members_email: "",
  };

  const yupSchema = Yup.object({
    members_cid: isCidExist ? Yup.string().required("Required") : null,
    members_branch_id: isCashier ? null : Yup.string().required("Required"),
    members_programlist_id: Yup.string().required("Required"),
    members_fname: Yup.string().required("Required"),
    // members_mname: Yup.string().required("Required"),
    members_lname: Yup.string().required("Required"),
    // members_agent: Yup.string().required("Required"),
  });

  const handleClose = () => {
    setAdd(false);
  };

  const handleChange = (e) => {
    setIsCidExist(!isCidExist);
    if (e.target.checked) {
      setText("with manual input CID");
    } else {
      setText("with auto-generated CID");
    }
  };

  return (
    <>
      <div className="modal modal-add-employee">
        <div className="display-center">
          <div className="title-container t-exbold notify-info">
            <h4 className="modal-title">
              <span className="color--blue"> Add Member </span>
            </h4>
            <span className="btn--close">
              <GrFormClose onClick={handleClose} />
            </span>
          </div>
          <div className="bg--white">
            <Formik
              initialValues={initVal}
              validationSchema={yupSchema}
              onSubmit={async (values, { setSubmitting, resetForm }) => {
                // console.log(values);
                setLoading(true);
                const member = await fetchApi(
                  // devApiUrl + "/admin/members/create-members-partial.php",
                  devApiUrl + "/admin/members/create-members-cid.php",
                  values
                );

                // console.log(member);
                if (typeof member === "undefined") {
                  console.log("undefined");
                  setLoading(false);
                }

                if (!member.status) {
                  console.log(member.message);
                  dispatch(setError(true));
                  dispatch(
                    setMessage(`${values.members_cid} - ${member.message}`)
                  );
                  setLoading(false);
                }

                if (member.status) {
                  console.log("Member added");
                  const mid = member.data;
                  setLoading(false);
                  dispatch(setResultSet([]));
                  props.history.push(`/admin/members-edit?id=${mid}`);
                }
              }}
            >
              {(props) => {
                if (!isCidExist) {
                  props.values.members_cid = "";
                }

                return (
                  <Form>
                    {!isCashier && (
                      <div className="content-box">
                        <InputSelect
                          label={`Branch Code (${text})`}
                          name="members_branch_id"
                          disabled={props.isSubmitting}
                        >
                          {resultData.length > 0 ? (
                            <>
                              <option value=""> -- </option>
                              {resultData.map((item) => (
                                <option
                                  key={item.branch_aid}
                                  value={item.branch_aid}
                                >
                                  {item.branch_code}
                                </option>
                              ))}
                            </>
                          ) : (
                            <option value=""> -- </option>
                          )}
                        </InputSelect>
                      </div>
                    )}

                    <div className="content-box">
                      <div className="d-flex">
                        <input
                          name="cid"
                          id="cid"
                          type="checkbox"
                          checked={isCidExist ? true : false}
                          onChange={handleChange}
                        />
                        <label className="label" htmlFor="cid">
                          Add Existing CID
                        </label>
                      </div>

                      <InputText
                        type="text"
                        name="members_cid"
                        disabled={isCidExist ? false : true}
                        onKeyPress={handleKey}
                      />
                    </div>

                    {/* <div className="content-box">
                      <InputSelect
                        label="Agent / Coordinator"
                        name="members_agent"
                        disabled={props.isSubmitting}
                      >
                        {coordinators.length > 0 ? (
                          <>
                            <option value=""> -- </option>
                            {coordinators.map((item) => (
                              <option
                                key={item.coordinator_aid}
                                value={item.coordinator_id}
                              >
                                {item.coordinator_name}
                              </option>
                            ))}
                          </>
                        ) : (
                          <option value=""> -- </option>
                        )}
                      </InputSelect>
                    </div> */}

                    <div className="content-box">
                      <InputSelect
                        label="Program Type"
                        name="members_programlist_id"
                      >
                        {result.length > 0 ? (
                          <>
                            <option value=""> -- </option>
                            {result.map((item) => (
                              <option
                                key={item.programlist_aid}
                                value={item.programlist_aid}
                              >
                                {item.programlist_name}
                              </option>
                            ))}
                          </>
                        ) : (
                          <option value=""> -- </option>
                        )}
                      </InputSelect>
                    </div>

                    <div className="content-box">
                      <InputText
                        label="First Name"
                        type="text"
                        name="members_fname"
                        disabled={props.isSubmitting}
                      />
                    </div>

                    {/* <div className="content-box">
                      <InputText
                        label="Middle Name"
                        type="text"
                        name="members_mname"
                        disabled={props.isSubmitting}
                      />
                    </div> */}

                    <div className="content-box">
                      <InputText
                        label="Last Name"
                        type="text"
                        name="members_lname"
                        disabled={props.isSubmitting}
                      />
                    </div>

                    {/* <div className="content-box">
                      <InputText
                        label="Email"
                        type="email"
                        name="members_email"
                        disabled={props.isSubmitting}
                      />
                    </div> */}

                    <div className="button-container">
                      <button
                        type="submit"
                        className="btn"
                        disabled={props.isSubmitting}
                      >
                        SAVE {loading && <SpinnerButton />}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalAddMember;
